module.exports = __webpack_public_path__ + "img/layout_top_tree_left.2178fbc0.svg";